import deepPurple from 'material-ui/colors/deepPurple';
import amber from 'material-ui/colors/amber';

export default {
    direction: 'rtl',
    palette: {
        primary: {
            light: deepPurple[300],
            main: deepPurple[500],
            dark: deepPurple[700],
        },
        secondary: {
            light: amber[300],
            main: amber['A700'],
            dark: amber[700],
        }
    },
    status: {
        danger: 'orange',
    },
    typography: {
        fontFamily: 'IRANSans',
        button: {
            fontWeight: 400,
            textAlign: 'capitalize'
        },
    },
};



// WEBPACK FOOTER //
// ./containers/themes/purpleTheme.js